export enum Colors {
  MYOPIA_ON_SET_TRESHOLD = 'rgb(99, 106, 113, 1)',
  NO_MYOPIA_PRESENT = 'rgb(255, 255, 255, 0)',
  PRE_MYOPIA_POSSIBLE = 'rgb(207, 224, 242, 0.8)',
  MYOPIA_PRESENT = 'rgb(33, 133, 224, 0.4)',
  HORIZONTAL_ZERO = 'rgb(99, 106, 113, 0.5)',
  VALUE = 'rgb(20, 136, 202, 1)',
}
